// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Należy ponowić próbę, używając pełnego formatu daty podobnego do następującego: ' +
    p['dateExample'] +
    '.',
  chart_labelGroup: () => 'Grupa',
  chart_labelSeries: () => 'Seria',
  chart_labelValue: () => 'Wartość',
  checkboxSet_requiredMessageDetail: () => 'Wymagane',
  checkbox_requiredMessageDetail: () => 'Wymagane',
  close: () => 'Zamknij',
  collection_noData: () => 'Brak danych do wyświetlenia.',
  collection_selectAllRows: () => 'Wybór wszystkich wierszy',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Wybór wiersza "' + p['ROW_NAME'] + '"',
  collection_sortDisabled: () => 'Niesortowalne',
  collection_sortEnabled: () => 'Sortowalne',
  confirmation: () => 'Potwierdzenie',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' z ' + p['totalCount'],
  dataVisualization_noData: () => 'Brak danych do wyświetlenia',
  dataVisualization_stateSelected: () => 'Wybrane',
  dataVisualization_stateUnselected: () => 'Niewybrane',
  error: () => 'Błąd',
  expandableList_expandCollapseInstructionText: () =>
    'Do rozwijania i zwijania proszę używać klawiszy ze strzałkami',
  expandableList_groupCollapse: () => 'Zwinięte',
  expandableList_groupExpand: () => 'Rozwinięte',
  filePicker_addFiles: () => 'Dodaj pliki',
  filePicker_dropzonePrimaryText: () => 'Przeciąganie i upuszczanie',
  filePicker_dropzoneSecondaryText: () => 'Proszę wybrać plik lub go tutaj przeciągnąć',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Proszę wybrać pliki lub je tutaj przeciągnąć',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Nie można wysłać plików typu ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Proszę wysyłać po jednym pliku',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Nie można wysłać plików typu ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'nieznany',
  formControl_clear: () => 'Wyczyść',
  formControl_day: () => 'Dzień',
  formControl_helpAvailable: () => 'Pomoc dostępna',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Osiągnięto limit ' +
    ((
      {
        one: '1 znaku',
        few: new Intl.NumberFormat('pl').format(p['CHARACTER_LIMIT']) + ' znaków',
        many: new Intl.NumberFormat('pl').format(p['CHARACTER_LIMIT']) + ' znaków'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('pl').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('pl').format(p['CHARACTER_LIMIT']) + ' znaku') +
    '.',
  formControl_loading: () => 'Ładowanie',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Przekroczono maksymalną długość ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Pozostało znaków: ' + p['CHARACTER_COUNT'] + '.',
  formControl_month: () => 'Miesiąc',
  formControl_readOnly: () => 'Tylko do odczytu',
  formControl_requiredMessageDetail: () => 'Proszę wprowadzić wartość.',
  formControl_year: () => 'Rok',
  gantt_labelDate: () => 'Data',
  gantt_labelEnd: () => 'Koniec',
  gantt_labelLabel: () => 'Etykieta',
  gantt_labelRow: () => 'Wiersz',
  gantt_labelStart: () => 'Początek',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nie znaleziono zgodnej sekcji.',
  indexer_keyboardInstructionText: () => 'Aby wybrać wartość, proszę nacisnąć klawisz Enter.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Między ' + p['FROM_SECTION'] + ' a ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Aby przełączyć się do trybu gestów, proszę 2x stuknąć i przytrzymać, a następnie - aby dostosować wartość - przeciągnąć w górę lub w dół.',
  info: () => 'Informacja',
  inputDateMask_date_cleared: () => 'Data wyczyszczenia',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Pusty',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'rrrr',
  inputNumber_converterParseError: () => 'Proszę wprowadzić liczbę.',
  inputNumber_decrease: () => 'Zmniejsz',
  inputNumber_increase: () => 'Zwiększ',
  inputPassword_hidden: () => 'Hasło ukryte',
  inputPassword_hide: () => 'Ukryj hasło',
  inputPassword_show: () => 'Pokaż hasło',
  list_suggestion: () => 'Sugestia',
  messageToast_allMessagesClosed: () => 'Wszystkie wyskakujące powiadomienia są zamknięte.',
  message_close: () => 'Zamknij',
  message_confirmation: () => 'Powodzenie',
  message_error: () => 'Błąd',
  message_info: () => 'Informacja',
  message_navigationFromMessagesRegion: () =>
    'Wchodzenie do obszaru komunikatów. Aby się cofnąć do elementu, na którym znajdował się fokus, proszę nacisnąć klawisz F6.',
  message_navigationToMessagesRegion: () =>
    'W obszarze komunikatów są nowe komunikaty. Aby przejść do nich, proszę nacisnąć klawisz F6.',
  message_warning: () => 'Ostrzeżenie',
  noData_message: () => 'Brak elementów do wyświetlenia',
  overflowItemLabel: () => 'Więcej kart',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'W toku',
  radio_helpForRadio: () => 'Pomoc dot. przycisku radiowego',
  radio_requiredMessageDetail: () => 'Proszę wybrać wartość.',
  selectMultiple_apply: () => 'Zastosuj',
  selectMultiple_back: () => 'Wstecz',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Aby usunąć wybraną wartość, proszę nacisnąć klawisz Backspace lub Delete',
  selectMultiple_selectedValues: () => 'Wybrane wartości',
  selectMultiple_showSelectedValues: () => 'Pokaż tylko wybrane wartości.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' wybrane wartości.',
  select_addToList: () => 'Dodaj do listy',
  select_addToListAvailable: () => 'Dodaj do listy (dostępne)',
  select_moreSearchOptions: () => 'Więcej opcji wyszukiwania',
  select_moreSearchOptionsAvailable: () => 'Więcej opcji wyszukiwania (dostępne)',
  select_noMatchesFound: () => 'Nie znaleziono zgodnych.',
  select_oneMatchFound: () => 'Znaleziono zgodnych: 1',
  select_requiredMessageDetail: () => 'Proszę wybrać wartość.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => 'Znaleziono zgodnych: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Znaleziono zgodnych: ' + p['TOTAL_SIZE'] + ' lub więcej',
  selector_selected: () => 'Pole wyboru zaznaczone',
  selector_unselected: () => 'Pole wyboru niezaznaczone',
  tabBarNavigationList_removeCueText: () => 'Możliwe do usunięcia',
  timeComponent_tooltipZoomIn: () => 'Powiększ',
  timeComponent_tooltipZoomOut: () => 'Pomniejsz',
  train_current: () => 'Bieżące',
  train_message_type: () => 'Typ wiadomości',
  train_not_visited: () => 'Nieodwiedzone',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Etap ' + p['currentStep'] + ' z ' + p['numberOfSteps'],
  train_visited: () => 'Odwiedzone',
  userAssistance_learnMore: () => 'Dalsze informacje',
  userAssistance_required: () => 'Wymagane',
  viz_drillable: () => 'Możliwe do drążenia',
  warn: () => 'Ostrzeżenie'
};
export default bundle;
